<template>

	<div class="abow_wbox bkf7">
		<div class="inter">
			<div class="n_content_ti"><span>帮助中心</span> </div>
			<div class="de_content_box">

				<div class="de_content_box2">
						<ul class="nmenu_list">
					<li @click="chose(item)" :class="{ 'active': active == item.id }"
						v-for="(item, index) in menu_list">
						{{ item.name }}
					</li>
				</ul>
				</div>
			
				<div class="content_nbox content_nbox2">

					<div class="new_list">

						<div class="item" v-for="item in list">


							<router-link :title="item.title" :to="{ path: '/shownews', query: { id: item.id } }"
								>
								<span class="sp1"></span> <span class="sp2">{{ item.title }}</span>
							</router-link>
						</div>
					</div>
						<el-pagination class="pagebox pagebox2" background @size-change="handleSizeChange"
							@current-change="handleCurrentChange" :current-page="current_page"
							:page-sizes="[10, 20, 30, 40, 50]" :page-size="10"
							layout="prev, pager, next" :total="total">
						</el-pagination>
				</div>

			</div>
		</div>
	</div>

</template>


<script>
export default {
	data() {
		return {
			list: [],
			content: "",
			active: 0,
			title: "",
			index: 0,
			menu_list: [],
			current_page: 1,
			pagesize: 10,
			total: 0,
			last_page: 0,
		}
	},
	created: function (data) {
		if (this.$route.query.id != undefined) {
			this.active = this.$route.query.id
			this.index = this.$route.query.index
		}
		this.getmenu();

	},
	watch: {
		$route() {

		}
	},
	methods: {
		chose(item) {
			this.active = item.id;
			this.current_page = 1;
			this.pagesize = 10;
			this.addRandomData(this.active, this.current_page);
		},
		getmenu() {
			var that = this;
			this.rq.requests.post("api/game/cms/getChannel", {
				id: 3,
			}).then(res => {
				that.menu_list = res.data;
				that.active = that.menu_list[0].id;
				that.current_page = 1;
				that.pagesize = 10;
				that.addRandomData(that.active, that.current_page);
			}).catch(error => {

			})
		},

		addRandomData(id, current_page, pagesize) {
			this.loading = true;
			var that = this;
			var filter = {};

			this.rq.requests.post("api/game/cms/arclist", {
				channel: id,
				page: current_page,
				pagesize: that.pagesize,
				paginate: true,
			}).then(res => {

				that.last_page = res.data.last_page;
				that.current_page = res.data.current_page;
				that.total = res.data.total;
				that.list = res.data.data;
				that.loading = false

			}).catch(error => {

			})
		},

		handleSizeChange(val) {

			this.pagesize = val;
			this.addRandomData(this.$data.channel, this.$data.current_page, val);
		},
		handleCurrentChange(val) {
			this.current_page = val;
			this.addRandomData(this.$data.channel, this.$data.current_page, this.$data.total);
		},



	}


}
</script>